import {UserFullReport} from "./UserFullReport";
import {UserFullReportMunicipality} from "./UserFullReportMunicipality";

// С4 — Обща справка по ползвател (като С3, но без таблицата със замените).
export const ReportS4General = () => (
    <UserFullReport title="С4 — Обща справка по ползвател" variant="general" showDeals={false}/>
);

// Ъ16: С4 за цяла община — всички землища с декларация.
export const ReportS4GeneralMunicipality = () => (
    <UserFullReportMunicipality title="С4 — Обща справка по ползвател" variant="general" showDeals={false}/>
);
